import React, {useState, useEffect} from 'react';
import {
    Route,
    Link,
    Switch,
    Redirect
} from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Register from './components/Register';
import {PageNotFound} from './components/PageNotFound';
import Home from './components/Home';
import Thankyou from './components/Thankyou';
import {makeStyles} from '@material-ui/core/styles';
import {Typography} from '@material-ui/core';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import {useSelector, useDispatch } from 'react-redux';
import {Button} from '@material-ui/core'
import { useHistory } from "react-router-dom";
import allActions from './actions';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

const useStyles = makeStyles((theme) => ({
    header: {
        background: '#fff',
        padding: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1)',
        position: 'relative',
        zIndex: 9,
        height: '100px'
    },
    container: {
        width: 800,
        margin: '0 auto',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        }
    },
    logo: {
        margin: '0 20px 0 0',
    },
    headerTitle: {
        borderLeft: '1px solid #eeeeee',
        padding: '0 20px',
        '& p': {
            fontSize: 30,
            fontWeight: '700',
            color: '#fcb716',
            lineHeight: '30px'
        }
    },
    doctor: {
        color: '#007c9d !important',
    },
    mainContent: {
        background: '#fff',
        padding: 30,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'centre',
        height: '100%',
        flexDirection: 'column',
        [theme.breakpoints.down('xs')]: {
            padding: 16
        }
    },
    registerLink: {
        color: '#007c9d',
        fontWeight: '700',
        textDecoration: 'none'
    },
    flex: {
        display: 'flex',
        alignItems: 'center'
    },
    userOptions:{
        '& a':{
            color: '#007c9d',
            '& svg':{
                width: 40,
                height: 40,
            }
        }
    }
}));

function App() {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch()
    const currentUser = useSelector(state => state.currentUser)
    const handleLogout = async () => {
        localStorage.removeItem('currentUser')
        dispatch(allActions.userActions.logOut())
        history.push('/login')
    }
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(true);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <div className={!currentUser.loggedIn ? classes.container : {}}>
                {!currentUser.loggedIn ? 
                <header className={classes.header}>
                    <div className={classes.flex}>
                        <Link to="/" className={classes.logo}>
                            <img style={{width: '60%'}} src={require('./images/Apollo Doctor Partner Logo-01.png')}  width="80"/>
                        </Link>
                    </div>
                    {/* <Link to="/register" className={classes.registerLink}>Register</Link> */}
                    {/* {!window.location.pathname.includes('register') && <Link to="/login" className={classes.registerLink}>Login</Link>} */}
                </header> :
                <header className={classes.header}>
                <div>
                        <Link to="/" className={classes.logo}>
                            <img style={{width: '60%', height: '200px'}} src={require('./images/Apollo Doctor Partner Logo-01.png')}  width="80"/>
                        </Link>
                    </div>
                    <div className={classes.userOptions}>
                        <Button color="secondary" onClick={handleLogout} >Logout</Button>
                    </div>
                </header>}
                <div className={classes.mainContent}>
                    <Switch>
                        <Route exact path={["/", "/index.html"]} render={() => (
                            currentUser && currentUser.loggedIn ? <Redirect to="/dashboard" /> : <Redirect to="/login" />
                        )}/>
                        <Route exact path="/onboard/:id" component={Home}/>
                        <Route exact path="/register/:id" component={Register}/>
                        <Route exact path="/register/:id/edit/:doctorId" component={Register}/>
                        <Route exact path="/thankyou" component={Thankyou}/>
                        <Route exact path="/login" component={Login}/>
                        <Route exact path="/404" component={PageNotFound}/>
                        <PrivateRoute authed={currentUser && currentUser.loggedIn} path='/dashboard' component={Dashboard} />
                        <Route render={() => (
                            currentUser && currentUser.loggedIn ? <Redirect to="/dashboard" /> : <Redirect to="/login" />
                        )}/>
                    </Switch>
                </div>
            </div>
        </div>
    );
}

export default App;
